import { render, staticRenderFns } from "./jlfw.vue?vue&type=template&id=45df1c64&scoped=true"
import script from "./jlfw.vue?vue&type=script&lang=js"
export * from "./jlfw.vue?vue&type=script&lang=js"
import style0 from "./jlfw.vue?vue&type=style&index=0&id=45df1c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df1c64",
  null
  
)

export default component.exports